import React, { Component } from 'react'
import loadScript from 'load-script'

import classNames from './AreaPicker.css'
import LoadingSpinner from '../LoadingSpinner'
import { MAPS_API_CALLBACK, MAPS_API_URL, GEO_LOOKUP_URL } from '../../constants'

const SEARCH_DELAY = 500

export default class LocationPicker extends Component {
  static defaultProps = {
    value: {
      lat: 51.509,
      lon: -0.197
    }
  }
  state = {
    searchTerm: '',
    fetching: false,
    results: []
  }
  searchTimeout = null
  componentDidMount () {
    const { hideMap, value: { lat, lon } } = this.props
    if (hideMap) {
      return
    }
    getMapsSDK().then(maps => {
      this.map = new maps.Map(this.refs.map, {
        center: { lat, lng: lon },
        zoom: 10,
        disableDefaultUI: true,
        zoomControl: true
      })
      this.marker = new maps.Marker({
        map: this.map,
        position: { lat, lng: lon }
      })
      this.map.addListener('click', this.onMapClick)
    })
  }
  onMapClick = e => {
    const { onChange } = this.props
    onChange({
      lat: e.latLng.lat(),
      lon: e.latLng.lng()
    })
  }
  componentWillReceiveProps (nextProps) {
    const { value, hideMap } = this.props
    if (hideMap) {
      return
    }
    if (value.lat !== nextProps.value.lat || value.lon !== nextProps.value.lon) {
      const coords = {
        lat: nextProps.value.lat,
        lng: nextProps.value.lon
      }
      this.map.panTo(coords)
      this.marker.setPosition(coords)
    }
  }
  onSearchChange = e => {
    clearTimeout(this.searchTimeout)
    this.setState({ searchTerm: e.target.value })
    this.searchTimeout = setTimeout(this.fetchLocations, SEARCH_DELAY)
  }
  fetchLocations = () => {
    const { searchTerm } = this.state
    const url = `${GEO_LOOKUP_URL}?address=${searchTerm}`
    this.setState({ fetching: true })
    window.fetch(url)
      .then(response => response.json())
      .then(data => {
        if (searchTerm !== this.state.searchTerm) {
          // Search term has changed, so bail out
          return
        }
        this.setState({
          fetching: false,
          results: data.results
        })
      })
  }
  renderResult = (result, value, onChange) => {
    const onClick = () => {
      this.setState({
        searchTerm: '',
        results: []
      })
      onChange({
        ...value,
        lat: result.geometry.location.lat,
        lon: result.geometry.location.lng,
        address: result.formatted_address
      })
    }
    return (
      <li key={result.place_id} className={classNames.resultItem}>
        <button onClick={onClick} className={classNames.resultButton}>
          {result.formatted_address}
        </button>
      </li>
    )
  }
  render () {
    const { value, onChange, disabled, hideMap } = this.props
    const { searchTerm, fetching, results } = this.state
    return (
      <div className={disabled ? classNames.pickerDisabled : classNames.picker}>
        <div className={classNames.searchWrapper}>
          <input
            type='text'
            value={searchTerm}
            onChange={this.onSearchChange}
            placeholder='Search for a location'
          />
          {results.length !== 0 &&
            <ul className={classNames.resultList}>
              {results.map(result => this.renderResult(result, value, onChange))}
            </ul>
          }
          {fetching &&
            <LoadingSpinner className={classNames.spinner} />
          }
        </div>
        {!hideMap &&
          <div ref='map' className={classNames.map} />
        }
        <label className={classNames.noMargin}>
          Selected location
          <div className={classNames.currentLocation}>
            {value.address || (value.lat && value.lon ? `${value.lat.toFixed(3)}, ${value.lon.toFixed(3)}` : 'None')}
          </div>
        </label>
      </div>
    )
  }
}

function getMapsSDK () {
  return new Promise(resolve => {
    if (window.google) {
      resolve(window.google.maps)
    } else {
      window[MAPS_API_CALLBACK] = () => resolve(window.google.maps)
      loadScript(MAPS_API_URL)
    }
  })
}



// WEBPACK FOOTER //
// ./src/components/search/LocationPicker.js